import { PORTAL_PATH } from "@/layouts/portal/portalNavigation";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
	loader: () => {
		throw redirect({ to: PORTAL_PATH.Home });
	},
});
